import { Picture, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

const DiamondInfo = ({ content, currentStepName }) => (
  <>
    <Picture
      alt=""
      fallback={`${sl.config.jewlr_asset_url}images/product/diamond/additional-info/${content.img}_2x.jpg`}
      mb={2}
      srcSet={[
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `
                ${`${sl.config.jewlr_asset_url}images/product/diamond/additional-info/${content.img}_mobile.jpg`} 550w,
              `,
        },
        {
          media: "(min-width: 768px)",
          sizes: "400px",
          srcSet: `
                ${`${sl.config.jewlr_asset_url}images/product/diamond/additional-info/${content.img}.jpg`} 378w,
                ${`${sl.config.jewlr_asset_url}images/product/diamond/additional-info/${content.img}_2x.jpg`} 756w
              `,
        },
      ]}
      width="90%"
    />
    <Typography bold fontSize={15} mb={2}>
      {content.description}
    </Typography>
    <Typography fontSize={14} mb={2}>
      {content.text}
    </Typography>
    {currentStepName !== "choose_gemstone" && (
      <Typography fontSize={14}>Shown under magnification.</Typography>
    )}
  </>
)

DiamondInfo.propTypes = {
  content: PropTypes.object,
  currentStepName: PropTypes.string,
}

export default DiamondInfo
